var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPretentionChartLine = function SvgPretentionChartLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#64748B",
    d: "M13.492 1.667H6.508c-3.033 0-4.841 1.808-4.841 4.842v6.975c0 3.041 1.808 4.85 4.841 4.85h6.975c3.034 0 4.842-1.809 4.842-4.842V6.509c.008-3.034-1.8-4.842-4.833-4.842",
    opacity: 0.35
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#64748B",
    d: "M14.025 7.842a.6.6 0 0 0-.317-.317.6.6 0 0 0-.216-.042h-1.55a.58.58 0 0 0-.584.584.58.58 0 0 0 .584.583h.15l-1.759 1.758-.85-1.266a.6.6 0 0 0-.425-.259.56.56 0 0 0-.466.167l-2.484 2.483a.59.59 0 0 0 0 .825.56.56 0 0 0 .409.167c.15 0 .3-.058.408-.167l1.983-1.983.85 1.267c.1.141.25.241.425.258a.56.56 0 0 0 .467-.167l2.267-2.266v.15a.58.58 0 0 0 .583.583.58.58 0 0 0 .583-.583V8.058c-.016-.075-.025-.15-.058-.216"
  })));
};
export default SvgPretentionChartLine;